import { takeEvery, put, call } from "redux-saga/effects"
import {
  GET_DEPARTMENTS,
  ADD_DEPARTMENT,
  UPDATE_DEPARTMENT,
  DELETE_DEPARTMENT
} from './actionTypes';
import { 
  getDepartmentsSuccess,
  getDepartmentsFail,
  addDepartmentSuccess,
  addDepartmentFail,
  updateDepartmentSuccess,
  updateDepartmentFail,
  deleteDepartmentSuccess,
  deleteDepartmentFail,
  showLoading, 
  hideLoading 
} from './actions';
import {
  getDepartments,
  addDepartment,
  updateDepartment,
  deleteDepartment
} from "../../helpers/backend_helper"
import { showToast } from '../../components/Toast';

function* fetchDepartments() {
  try {
    yield put(showLoading(true))
    const response = yield call(getDepartments)
    yield put(getDepartmentsSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(showLoading(true))
    yield put(getDepartmentsFail(error))
  }
}

function* onAddDepartment({ payload: department }) {
  try {
    yield put(showLoading(true))
    const response = yield call(addDepartment, department)
    showToast("New Department is added")
    yield put(addDepartmentSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(showLoading(true))
    yield put(addDepartmentFail(error.response))
  }
}

function* onUpdateDepartment({ payload: department }) {
  try {
    yield put(showLoading(true))
    const response = yield call(updateDepartment, department)
    showToast("Changes Successfully Applied")
    yield put(updateDepartmentSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(hideLoading(false))
    yield put(updateDepartmentFail(error))
  }
}

function* onDeleteDepartment({ payload: department }) {
  try {
    yield put(showLoading(true))
    const response = yield call(deleteDepartment, department)
    showToast("Department is deleted from the system")
    yield put(deleteDepartmentSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(hideLoading(false))
    yield put(deleteDepartmentFail(error))
  }
}

function* deptSaga() {
  yield takeEvery(GET_DEPARTMENTS, fetchDepartments)
  yield takeEvery(ADD_DEPARTMENT, onAddDepartment)
  yield takeEvery(UPDATE_DEPARTMENT, onUpdateDepartment)
  yield takeEvery(DELETE_DEPARTMENT, onDeleteDepartment)
}

export default deptSaga;






























// import io from 'socket.io-client';
// function connect() {
//   // const socket = io('https://koru.herokuapp.com/departments', {
//   //   autoConnect: false,
//   //   reconnection: true
//   // });
//   const socket = io('https://koru-backend.herokuapp.com/departments', {
//     autoConnect: false,
//     reconnection: true
//   });
//   socket.open();
//   return new Promise((resolve) => {
//     socket.on('connect', () => {
//       resolve(socket);
//     });
//   });
// }
// export function* listenForUpdates(socket) {
//   return new eventChannel((emit) => {
//     const update = (departments) => {
//       return emit(getDepartmentsSuccess(departments));
//     };
//     socket.on('get_departments', update);
//     return () => {};
//   });
// }

// export function* fetchDepartments(socket) {
//   yield put(showLoading(true));
//   const channel = yield call(listenForUpdates, socket);
//   while (true) {
//     let action = yield take(channel);
//     yield put(action);
//     yield put(hideLoading(false));
//   }
// }

// export function* onAddNewDepartment(socket) {
//   while (true) {
//     yield put(showLoading(true));
//     const { payload: department } = yield take(ADD_NEW_DEPARTMENT);
//     socket.emit('add_department', department);
//     showToast('New Department is added');
//     yield put(hideLoading(false));
//   }
// }

// export function* onUpdateDepartment(socket) {
//   while (true) {
//     yield put(showLoading(true));
//     const { payload: department } = yield take(UPDATE_DEPARTMENT);
//     socket.emit('update_department', department);
//     showToast('Department is updated');
//     yield put(hideLoading(false));
//   }
// }

// export function* onDeleteDepartment(socket) {
//   while (true) {
//     yield put(showLoading(true));
//     const { payload: department } = yield take(DELETE_DEPARTMENT);
//     socket.emit('delete_department', department);
//     showToast('Department is deleted', 'success');
//     yield put(hideLoading(false));
//   }
// }

// function* deptSaga() {
//   yield take(GET_DEPARTMENTS);
//   const socket = yield call(connect);
//   yield fork(fetchDepartments, socket);
//   yield fork(onAddNewDepartment, socket);
//   yield fork(onUpdateDepartment, socket);
//   yield fork(onDeleteDepartment, socket);
// }

